module.exports = __webpack_public_path__ + "images/emoji/round_pushpin.44de48cb9f16c397d652.png";